<template>
  <v-container fluid>
    <v-row justify="center" align-content="center" class="mt-5">
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-card outlined>
          <v-app-bar flat dense>
            <v-toolbar-title>
              <v-img src="@/assets/kobelco_logo.png" contain height="30"> </v-img>
            </v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-img src="@/assets/kobelink_logo.png" contain height="100" class="mx-auto"> </v-img>
            <div v-if="env !== 'production'">
              <v-form v-model="loginForm.valid" @submit.prevent="login" ref="loginForm" class="mt-3">
                <v-row>
                  <v-col cols="12">
                    <v-alert :value="loginForm.error.show" type="error" dense class="mt-2 mb-0">
                      {{ loginForm.error.text }}
                    </v-alert>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="loginForm.userName"
                      prepend-inner-icon="mdi-account"
                      placeholder="Username"
                      outlined
                      clearable
                      hide-details
                      dense
                      class="text-body-2"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      @click:append="loginForm.showPassword = !loginForm.showPassword"
                      v-model="loginForm.password"
                      :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="loginForm.showPassword ? 'text' : 'password'"
                      prepend-inner-icon="mdi-lock"
                      placeholder="Password"
                      outlined
                      clearable
                      hide-details
                      dense
                      class="text-body-2"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="login" color="primary" depressed block>
              {{ $t('login') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Login',
    data: () => ({
      loginForm: {
        userName: '',
        password: '',
        valid: false,
        error: {
          show: false,
          text: '',
        },
        showPassword: false,
      },
    }),
    computed: {
      ...mapGetters('loading', ['loading']),
      ...mapGetters('auth', ['access_token']),
      env: () => process.env.NODE_ENV,
    },
    methods: {
      ...mapActions('auth', ['get_access_token']),
      async login() {
        if (process.env.NODE_ENV === 'production') {
          if (!this.$msal.isAuthenticated()) {
            this.$store.commit('loading/start_loading');
            this.$msal.signIn();
          } else {
            this.$router.push('/');
          }
          this.$store.commit('loading/end_loading');
        } else {
          try {
            this.$store.commit('loading/start_loading');
            this.loginForm.error = {
              show: false,
              text: '',
            };
            await this.get_access_token({ userName: this.loginForm.userName, password: this.loginForm.password });
            this.$router.push('/');
          } catch (error) {
            console.error(error);
            this.loginForm.error = {
              show: true,
              text: error.message,
            };
            this.$store.commit('loading/end_loading');
          }
        }
      },
    },
  };
</script>
